export default __webpack_public_path__ + "static/media/ISSO CLASS-10 EXAM PATTERN 2026-27.29950a06.pdf";